import React, { useEffect, useContext, useState } from "react";
import { Store } from "../../states/store";
import { getError } from "../../utils/error.js";
import { toast, ToastContainer } from "react-toastify";
import { Button, Spinner } from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axiosInstance from "../../utils/axiosUtil.js";

export default function EditPrivacyPolicyModel(props) {
  const { state } = useContext(Store);
  const { token, privacyPolicy } = state;
  const [load, setLoad] = useState(false);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike"],
      ["link", "image", "video"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["blockquote", "code-block"],
      [{ color: [] }, { background: [] }],
      ["clean"],
      ["paragraph"],
      [{ align: [] }],
      [{ font: [] }],
      [{ script: "sub" }, { script: "super" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ direction: "rtl" }],
    ],
  };
  const formats = [
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "code-block",
    "list",
    "bullet",
    "link",
    "image",
    "video",
    "font",
    "align",
    "color",
    "background",
    "header",
    "indent",
    "size",
    "script",
    "clean",
    "code",
    "direction",
  ];
  const [content, setContent] = useState("");

  useEffect(() => {
    setContent(privacyPolicy && privacyPolicy.desc);
  }, [privacyPolicy]);

  const resetForm = () => {
    setContent("");
  };

  const handleChange = (value) => {
    setContent(value);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    if (!content) {
      toast.warning("Please fill Some content before edit.");
      return;
    }
    try {
      setLoad(true);
      const { data } = await axiosInstance.post(
        `/api/admin/content`,
        {
          title: "PRIVACY_POLICY",
          desc: content,
        },
        {
          headers: {
            authorization: `${token}`,
          },
        }
      );
      if (data.success) {
        setLoad(false);
        toast.success("Privacy Poilicy Content Updated Succesfully.", {
          position: toast.POSITION.BOTTOM_CENTER,
        });
        resetForm();
        setTimeout(() => {
          props.onHide();
        }, 1500);
      } else {
        setLoad(false);
        toast.error(data.error.message, {
          position: toast.POSITION.BOTTOM_CENTER,
        });
      }
    } catch (err) {
      setLoad(false);
      toast.error(getError(err), {
        position: toast.POSITION.BOTTOM_CENTER,
      });
    }
  };

  return (
    <div className="m-3">
      <ReactQuill
        value={content}
        onChange={handleChange}
        modules={modules}
        formats={formats}
        style={{ border: "1px solid black" }}
      />
      <div className="m-2 d-flex gap-1 justify-content-end">
        <Button onClick={() => props.onHide()} variant="danger">
          Cancel
        </Button>
        <Button onClick={submitHandler} variant="primary">
          {load ? <Spinner animation="border" size="sm" /> : "Submit"}
        </Button>
        <ToastContainer />
      </div>
    </div>
  );
}
